import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-triggers',
  templateUrl: './workflow-triggers.component.html',
  styleUrls: ['./workflow-triggers.component.scss']
})
export class WorkflowTriggersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
